import React, { useEffect } from "react";
import { ThreeDotsHorizontalIcon, TickIcon, TrashIcon } from "Assets";
import { useNotification } from "./useNotification";
import { useAppDispatch } from "Redux/store";
import {
  checkNotificationsCount,
  checkUrgentNotifications,
  deleteAllNotifications,
  getNotifications,
  markAllAsRead,
} from "Redux/Notifications/reducer";
import { NOTIFICATIONS_LIMIT } from "Shared/Constants/app";
import NotificationsList from "./NotificationsList";
import { useSelector } from "react-redux";
import {
  selectNotifications,
  selectNotificationsCount,
} from "Redux/Notifications/slice";
import Meatballs from "Components/UI/Meatballs/Meatballs";
import IconCircleFrame from "Components/UI/IconCircleFrame/IconCircleFrame";
import { SideModal } from "Components/SideModal/SideModal";

type Props = {
  isOpen: boolean | null;
  onClose: () => void;
  className?: string;
};

export const Notification = ({ isOpen, onClose, className }: Props) => {
  const dispatch = useAppDispatch();

  const { dateRange } = useNotification();

  const notificationCount = useSelector(selectNotificationsCount);
  const notifications = useSelector(selectNotifications);

  const handleMarkAllAsRead = () => {
    dispatch(markAllAsRead());
  };

  useEffect(() => {
    const params = {
      created_after: dateRange.created_after,
      created_before: dateRange.created_before,
    };
    dispatch(checkUrgentNotifications(params));
    dispatch(checkNotificationsCount(params));
    dispatch(
      getNotifications({
        ...params,
        offset: 0,
        limit: NOTIFICATIONS_LIMIT,
      })
    );
  }, []);
  return (
    <SideModal
      isOpen={isOpen}
      className={className}
      onClose={onClose}
      title="Notifications"
      actionButtons={
        (notificationCount > 0 || notifications.results.length) && (
          <Meatballs<any>
            value={{}}
            onChange={(_v, optionKey) => {
              if (optionKey === "markAsRead") handleMarkAllAsRead();
              if (optionKey === "delete") dispatch(deleteAllNotifications());
            }}
            options={
              [
                notificationCount > 0 && {
                  label: "Mark all as read",
                  key: "markAsRead",
                  icon: <TickIcon />,
                },
                {
                  label: "Delete all",
                  key: "delete",
                  icon: <TrashIcon />,
                },
              ].filter(Boolean) as any
            }
          >
            <IconCircleFrame
              bgColor="transparent"
              icon={ThreeDotsHorizontalIcon}
            />
          </Meatballs>
        )
      }
    >
      <NotificationsList onClose={onClose} />
    </SideModal>
  );
};
